export class PasswordRequiredError extends Error {
  constructor() {
    super('Password required');
    this.name = 'PasswordRequiredError';
  }
}

export class WrongPasswordError extends Error {
  constructor() {
    super('Wrong password');
    this.name = 'WrongPasswordError';
  }
}

export class InvalidPdfError extends Error {
  constructor(cause?: unknown) {
    super(`Invalid PDF${cause instanceof Error ? `: ${cause.message}` : ''}`);
    this.name = 'InvalidPdfError';
  }
}

/** A user-facing error whose message is already localised. */
export class UserError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UserError';
  }
}

/** The user cancelled (e.g. declined an engine download): no error to show. */
export class CancelledError extends Error {
  constructor() {
    super('Cancelled');
    this.name = 'CancelledError';
  }
}
